import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Page } from 'react-pdf';
import { useAppSelector } from '../../hooks';
import { getSessionState } from '../../store/SessionSlice';
import QuestionPage from '../../pages/UserPages/Resources/components/QuestionPage';

interface PdfViewerBodyProps {
  selectedPageNumber: string;
  pageWidth?: number;
  scale: number;
  onAttempt: () => void;
  totalPages: number;
}

const PdfViewerBody: React.FC<PdfViewerBodyProps> = ({
  selectedPageNumber,
  pageWidth,
  scale,
  totalPages,
  onAttempt,
}) => {
  // Store
  const sessionState = useAppSelector(getSessionState);

  const questions = sessionState.session?.questions;

  const renderPage = () => {
    const questionPage = questions.find(
      (question) => question.pageNo === Number(selectedPageNumber)
    );

    if (questionPage) {
      return <QuestionPage questionPage={questionPage} pageWidth={pageWidth} />;
    }
    return (
      <Page
        pageNumber={
          Number(selectedPageNumber) -
            questions.filter(
              (question) => Number(question.pageNo) < Number(selectedPageNumber)
            ).length || 1
        }
        scale={scale}
        width={pageWidth}
        className="pdf-rounded"
      />
    );
  };

  return (totalPages + 1).toString() === selectedPageNumber ? (
    <>
      <div style={{ paddingTop: '30px' }}>
        <img
          src={`${process.env.PUBLIC_URL}/images/empty/empty-quiz.png`}
          alt="empty-quiz"
          style={{ width: '250px' }}
        />
      </div>
      <Stack alignItems="center">
        <Typography
          component="h3"
          color="secondary"
          fontWeight={500}
          textAlign="center"
          sx={{ m: '15px 0', maxWidth: '650px' }}
        >
          Before you begin the quiz, make sure you have a strong WIFI
          connection, a pen and paper to do any extra calculations and a water
          bottle or drink to get you thinking.
        </Typography>
        {onAttempt && (
          <Button variant="contained" color="primary" onClick={onAttempt}>
            Attempt a Quiz
          </Button>
        )}
      </Stack>
    </>
  ) : (
    // <div style={{ maxWidth: `calc(${pageWidth}px - 60px)` }}>
    <div style={{ maxWidth: pageWidth }}>{renderPage()}</div>
  );
};

export default PdfViewerBody;
